import React from "react";

export default function PopupModal({
  show,
  onClose,
  type,
  title,
  message,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Fondo oscuro semitransparente */}
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Caja modal */}
      <div className="relative w-full max-w-sm rounded-2xl border border-gray-700 bg-gradient-to-br from-gray-900 via-black to-gray-800 p-6 text-center text-white shadow-2xl animate-fadeIn">
        {/* Emoji ❌ o ✅ grande */}
        <div className="mb-4 text-5xl">
          {type === "error" ? "❌" : "✅"}
        </div>

        <h2 className="mb-2 text-lg font-bold">
          {title}
        </h2>

        <p className="mb-6 text-gray-300">
          {message}
        </p>

        <button
          type="button"
          onClick={onClose}
          className="rounded-lg bg-gray-700 px-4 py-2 text-white transition hover:bg-gray-600"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}